import * as React from "react";
import { forwardRef } from "react";
const SvgFail = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 9, height: 9, fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#E61B1B", d: "m5.773 4.5 2.965-2.965a.904.904 0 0 0 0-1.271.895.895 0 0 0-.981-.195.9.9 0 0 0-.292.195L4.5 3.229 1.535.264A.9.9 0 0 0 .553.069.9.9 0 0 0 0 .899c0 .238.094.466.262.636L3.227 4.5.262 7.465a.904.904 0 0 0 0 1.271.9.9 0 0 0 .981.195.9.9 0 0 0 .292-.195L4.5 5.771l2.965 2.965a.895.895 0 0 0 .982.195.895.895 0 0 0 .553-.83.9.9 0 0 0-.262-.636z" }));
const ForwardRef = forwardRef(SvgFail);
export { ForwardRef as ReactComponent };
